export default __webpack_public_path__ + "static/media/rangetubeImg_2.7755538f.webp";